import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clientPortalService, setClientToken, setCachedClient } from '../services/clientPortalService';

export default function ClientLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await clientPortalService.login(email.trim(), password);
      setClientToken(res.access_token);
      setCachedClient(res.client);
      navigate('/client/dashboard', { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F7F5] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 text-white text-xl font-bold shadow">
            C
          </div>
          <h1 className="mt-4 text-2xl font-semibold text-[#181818]">Client portal</h1>
          <p className="mt-1 text-sm text-[#6B7280]">Sign in to view your quotes, jobs, and invoices.</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="rounded-2xl border border-[#E6E6E4] bg-white p-6 shadow-sm space-y-4"
        >
          <div>
            <label className="text-xs font-medium text-gray-700">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="mt-1 h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-gray-700">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-1 h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            />
          </div>
          {error && (
            <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full h-10 rounded-lg bg-orange-500 text-sm font-semibold text-white hover:bg-orange-600 disabled:opacity-50"
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
          <p className="text-[11px] text-center text-[#6B7280]">
            Haven't been invited yet? Ask your contractor to send you a portal invite.
          </p>
        </form>
      </div>
    </div>
  );
}
